export class TypeSurvey {
    name: string;
    id: number;
    code: string;
}